import { EnrollTypeBE } from "../types";

const LABELS: Record<EnrollTypeBE, string> = {
  TOP: "Top-Down",
  TOP_MANDATORY: "Top-Down obbligatorio",
  AUTO: "Auto-iscrizione",
  BOTTOM: "Auto-iscrizione con approvazione",
  PRE_AUTO: "Auto-iscrizione",
  PRE_BOTTOM: "Auto-iscrizione con approvazione",
};

export const formatEnrollTypeLabel = (enrollType?: string | null): string => {
  if (!enrollType) return "";
  const key = enrollType.toUpperCase() as EnrollTypeBE;
  return LABELS[key] ?? enrollType;
};
